<template>
  <div class="form-check flex items-center">
    <input
      :class="[
        `form-input-${type}`,
        ...customClass,
        { 'form-field-error': vee ? vee.classes.failed : false },
      ]"
      :type="type"
      :name="name"
      :value="value"
      :checked="checked"
      :id="id"
      @input="update($event.target)"
    /><!--  @change="$emit('change', $event.target)"
      @blur="$emit('blur', $event.target)" -->
    <label :for="id" class="form-check-label ml-4" v-if="label">{{
      label
    }}</label>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'checked',
    event: 'input',
  },

  data() {
    return {}
  },

  props: {
    id: {
      type: String,
      default: '',
    },

    label: {
      type: String,
      default: '',
    },

    name: {
      type: String,
      default: '',
    },

    type: {
      type: String,
      default: '',
    },

    value: {
      type: [String, Boolean],
      default: '',
    },

    checked: {
      type: [String, Boolean],
      default: false,
    },

    customClass: {
      type: Array,
      default: () => [],
    },

    vee: {
      type: Object,
      default: () => {},
    },
  },

  methods: {
    update(input) {
      const value =
        typeof this.value === 'boolean'
          ? input.checked
          : input.checked
          ? input.value
          : ''
      this.$emit('input', value)
    },
  },
}
</script>
